module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    },
    on: {
      "cancela": function($event) {
        return _vm.cancela()
      }
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('upload-arquivos', {
    ref: "uploader",
    attrs: {
      "api": _vm.apiUrl,
      "endPoint": _vm.endPointUpload,
      "arquivos": _vm.anexosTemporarios,
      "podeDeletar": _vm.mostraDelete
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Enviar",
      "icone": "fa-upload"
    },
    on: {
      "clicado": function($event) {
        return _vm.enviaArquivo(_vm.cadastrado)
      }
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraTituloUpload),
      expression: "mostraTituloUpload"
    }]
  }, [_vm._v("\n                Envio de Arquivos\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraTituloEnvio),
      expression: "mostraTituloEnvio"
    }]
  }, [_vm._v("\n                Envio de Atualização Cadastral\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraTituloFinalizado),
      expression: "mostraTituloFinalizado"
    }]
  }, [_vm._v("\n                Atualização Cadastral Finalizada\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.salvando),
      expression: "salvando"
    }]
  }, [_c('h2', {
    staticClass: "carregando",
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("\n                          Salvando...\n                        ")])]), _vm._v(" "), (_vm.cadastrado.status === _vm.Status.RECADASTRAMENTO_PENDENTE) ? _c('div', [_vm._m(0)]) : _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Anexar' || _vm.tipoButao === 'Enviar'),
      expression: "tipoButao === 'Anexar' || tipoButao === 'Enviar'"
    }]
  }, [_c('p', [_vm._v("\n                            Clique em\n                            "), _c('strong', [_vm._v("ANEXAR")]), _vm._v(" para fazer o upload (envio\n                            de arquivos digitais) dos seus documentos\n                            digitalizados para suas alterações serem\n                            "), _c('strong', [_vm._v("validadas")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Anexar'),
      expression: "tipoButao === 'Anexar'"
    }]
  }, [_vm._v("\n                              , e abrir a opção\n                              "), _c('strong', [_vm._v("SALVAR")])]), _vm._v(".\n                          ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.listaDocumentosExigidos), function(documento) {
    return _c('ul', {
      key: documento
    }, [_c('li', [_vm._v(_vm._s(documento))])])
  })], 2), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Enviar'),
      expression: "tipoButao === 'Enviar'"
    }]
  }, [_vm._v("    \n                          Caso todos os campos a serem alterados estiverem\n                          completos e de acordo com seus dados mais atuais,\n                          clique em\n                          "), _c('strong', [_vm._v("ENVIAR")]), _vm._v(" para finalizar seu\n                          recadastramento.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "espacado"
  }, [(_vm.cadastrado.status === _vm.Status.RECADASTRAMENTO_PENDENTE) ? _c('botao', {
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Confirmar",
      "icone": "ok-modal",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.confirma(_vm.cadastrado)
      }
    }
  }) : [_c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Anexar' && !this.salvando || _vm.situacaoInicial == _vm.Status.ALTERADO),
      expression: "tipoButao === 'Anexar' && !this.salvando || situacaoInicial == Status.ALTERADO"
    }],
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Anexar",
      "icone": "fa-upload",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.selecionaArquivo()
      }
    }
  }), _vm._v(" "), _c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Enviar'),
      expression: "tipoButao === 'Enviar'"
    }],
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Enviar",
      "icone": "fa-send",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.salvaValidado(_vm.cadastrado)
      }
    }
  })], _vm._v(" "), _c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraFinalizado),
      expression: "mostraFinalizado"
    }],
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Ver Protocolo",
      "icone": "fa-info-circle",
      "disabled": _vm.cadastrado.lancamentoPermitido
    },
    on: {
      "clicado": function($event) {
        return _vm.$router.push({
          name: 'Fim'
        })
      }
    }
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoButao === 'Anexar' || _vm.situacaoInicial == _vm.Status.ALTERADO),
      expression: "tipoButao === 'Anexar' || situacaoInicial == Status.ALTERADO"
    }],
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Envio de Atualização Cadastral")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "espacado"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde-lg",
      "rotulo": "Salvar",
      "icone": "salvar",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "clicado": function($event) {
        return _vm.salvaAlterado(_vm.cadastrado)
      }
    }
  })], 1)])])])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                          Caso não haja alteração e todos os seus dados estejam\n                          corretos, clique em\n                          "), _c('strong', [_vm._v("CONFIRMAR")]), _vm._v(" para enviar seu\n                          recadastramento.\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                            De acordo com suas alterações, segue a lista dos\n                            documentos necessários\n                            "), _c('strong', [_vm._v("(frente e verso)")]), _vm._v(":\n                          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                      A atualização ficará\n                      "), _c('strong', [_vm._v("pendente de anexação")]), _vm._v(", de documentação\n                      comprobatória (digitalizada).\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                      As informações\n                      "), _c('strong', [_vm._v("não validadas")]), _vm._v(" pelo setor competente\n                      (por inconsistência ou ausência de documentação\n                      comprobatória), "), _c('strong', [_vm._v("serão descartadas")]), _vm._v(",\n                      mantendo-se os dados já constantes no sistema.\n                    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-686609a8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recadastramento/envio/index.vue
// module id = gmzR
// module chunks = 5